// ============================================
// BannerVerComo — barra persistente del modo "Ver como" (2026-07-04)
// ============================================
// Se monta SIEMPRE en el shell del Dashboard (arriba de todo, en flujo — no
// fixed — para que empuje el layout y jamas tape la cabecera). Renderiza null
// si no hay modo activo, asi que fuera del modo es un no-op total.
//
// Ambar a proposito (pedido explicito: color distintivo de "estado especial",
// separado de la paleta Beep para que NUNCA se confunda con la app normal).
//
// Vigila la expiracion del token (30 min): 30s antes sale solo y restaura la
// sesion original del director con aviso — nunca lo deja atrapado.

import React, { useEffect, useState } from 'react';
import { metaVerComo, salirVerComo, consumirFlagVerComoTermino } from '../utils/verComo';

const PP = "'Poppins', sans-serif";

export default function BannerVerComo() {
  const meta = metaVerComo();
  const [saliendo, setSaliendo] = useState(false);
  const [restante, setRestante] = useState(() => (meta ? Math.max(0, meta.expira - Date.now()) : 0));
  // Toast de "la vista termino" (se muestra ya de vuelta en la sesion original).
  const [toastTermino, setToastTermino] = useState(() => consumirFlagVerComoTermino());

  // Vigia de expiracion: cada 10s. A <=30s del fin, salida automatica.
  useEffect(() => {
    if (!meta) return;
    const t = setInterval(() => {
      const queda = meta.expira - Date.now();
      setRestante(Math.max(0, queda));
      if (queda <= 30 * 1000) {
        clearInterval(t);
        salirVerComo('expiro');
      }
    }, 10 * 1000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta?.expira]);

  useEffect(() => {
    if (!toastTermino) return;
    const t = setTimeout(() => setToastTermino(false), 6000);
    return () => clearTimeout(t);
  }, [toastTermino]);

  if (!meta) {
    if (!toastTermino) return null;
    return (
      <div style={{
        position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
        background: '#8a6d00', color: '#fff', padding: '12px 18px', borderRadius: 10,
        fontSize: 14, fontFamily: PP, boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
        zIndex: 2000, maxWidth: 'calc(100vw - 32px)', textAlign: 'center',
      }}>
        La vista "Ver como" terminó y regresaste a tu sesión.
      </div>
    );
  }

  const minutos = Math.max(1, Math.round(restante / 60000));

  return (
    <div style={{
      // En flujo (flexShrink 0 dentro del shell en columna): empuja el
      // contenido hacia abajo, nunca tapa la cabecera ni el sidebar.
      flexShrink: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: 12, flexWrap: 'wrap',
      padding: 'calc(env(safe-area-inset-top, 0px) + 8px) 12px 8px',
      background: '#f59e0b', color: '#3b2f00',
      fontFamily: PP, fontSize: 14, lineHeight: 1.4,
    }}>
      <span style={{ fontWeight: 600, textAlign: 'center', minWidth: 0, overflowWrap: 'anywhere' }}>
        👁 Estás viendo la app como <strong>{meta.objetivo.nombre}</strong>
        <span style={{ fontWeight: 400, opacity: 0.85 }}> · {minutos} min restantes</span>
      </span>
      <button
        onClick={async () => { setSaliendo(true); await salirVerComo('manual'); }}
        disabled={saliendo}
        onPointerDown={(e) => { e.currentTarget.style.transform = 'scale(0.97)'; }}
        onPointerUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
        onPointerLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
        onPointerCancel={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
        style={{
          background: '#3b2f00', color: '#ffd977', border: 'none',
          padding: '10px 18px', borderRadius: 10, fontSize: 14, fontWeight: 700,
          cursor: saliendo ? 'wait' : 'pointer', fontFamily: PP, minHeight: 44,
          transition: 'transform 0.15s ease-out, opacity 0.15s ease-out',
          opacity: saliendo ? 0.7 : 1, flexShrink: 0,
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        {saliendo ? 'Saliendo…' : 'Salir de la vista'}
      </button>
    </div>
  );
}
